module.exports = __webpack_public_path__ + "img/arrow-down.c2cc3884.svg";